import {
  type ModelElement,
  type ViewDowncastWriter,
  Plugin,
  viewToModelPositionOutsideModelElement,
} from 'ckeditor5';

export default class Editing extends Plugin {
  init() {
    this._defineSchema();
    this._defineConverters();

    this.editor.editing.mapper.on(
      'viewToModelPosition',
      viewToModelPositionOutsideModelElement(this.editor.model, (viewElement) => viewElement.hasClass('__populate__-temporary')),
    );
  }

  _defineSchema() {
    const { schema } = this.editor.model;

    schema.register('temporary', {
      // Behaves like a self-contained inline object (e.g. an inline image)
      // allowed in places where $text is allowed (e.g. in paragraphs).
      // The inline widget can have the same attributes as text (for example linkHref, bold).
      inheritAllFrom: '$inlineObject',

      allowAttributes: [
        'value',
        'firstPosition',
        'lastPosition',
      ],
    });
  }

  _defineConverters() {
    const { conversion } = this.editor;

    // Helper method for both downcast converters.
    function createFieldView(modelItem: ModelElement, viewWriter: ViewDowncastWriter) {
      const value = modelItem.getAttribute('value') as string;

      const fieldView = viewWriter.createContainerElement('span', {
        class: '__populate__-temporary',
      });

      const innerText = viewWriter.createText(value);
      viewWriter.insert(viewWriter.createPositionAt(fieldView, 0), innerText);
      return fieldView;
    }

    conversion.for('editingDowncast').elementToElement({
      model: 'temporary',
      view: (modelItem, { writer: viewWriter }) => createFieldView(modelItem, viewWriter),
    });

    conversion.for('dataDowncast').elementToElement({
      model: 'temporary',
      view: (modelItem, { writer: viewWriter }) => createFieldView(modelItem, viewWriter),
    });
  }
}
